import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';
import { DESIGN_RIGHT_PANEL_WIDTH_VAR } from '../design-right-panel-resize.hook';

type EmptyStateOverlayProps = {
  visible: boolean;
  label?: string;
  rightInset?: number;
};

const useStyles = makeStyles()((theme) => ({
  overlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: `var(${DESIGN_RIGHT_PANEL_WIDTH_VAR}, 0px)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    zIndex: 1,
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: '1.5rem',
    textAlign: 'center',
    padding: theme.spacing(3),
  },
}));

export const EmptyStateOverlay = ({
  visible,
  label = 'Click anywhere to draw a new building',
  rightInset = 0,
}: EmptyStateOverlayProps) => {
  const { classes } = useStyles();

  if (!visible) return null;

  return (
    <div className={classes.overlay} style={{ right: rightInset }}>
      <Typography className={classes.label}>{label}</Typography>
    </div>
  );
};
